import { cn } from '@/lib/utils'
import { teams } from '@/content/world-cup-2026/data'

interface WcFlagProps {
    /** Team name — key into the World Cup teams → flag-code map. */
    team: string
    className?: string
}

/**
 * A small country flag from flagcdn.com. Renders nothing when the team has no
 * known flag code, so the team name still reads cleanly on its own.
 */
export const WcFlag = ({ team, className }: WcFlagProps) => {
    const code = teams[team]
    if (!code) {
        return null
    }

    return (
        // eslint-disable-next-line @next/next/no-img-element -- tiny external flag bitmaps, not local assets
        <img
            src={`https://flagcdn.com/16x12/${code}.png`}
            srcSet={`https://flagcdn.com/32x24/${code}.png 2x`}
            width={16}
            height={12}
            alt={team}
            loading="lazy"
            className={cn('inline-block rounded-[1px] align-middle', className)}
        />
    )
}

interface WcMatchProps {
    home: string
    away: string
    className?: string
}

/** Inline "🏴 Home vs 🏳 Away" pairing used in the schedule tables. */
export const WcMatch = ({ home, away, className }: WcMatchProps) => (
    <span className={cn('inline', className)}>
        <WcFlag team={home} className="mx-px" /> <span>{home}</span>{' '}
        <span className="text-[11px] font-normal text-[var(--wc-fg-3)]">vs</span>{' '}
        <WcFlag team={away} className="mx-px" /> <span>{away}</span>
    </span>
)
